import { render, staticRenderFns } from "./AccidentRelative.vue?vue&type=template&id=52da94ed&scoped=true&"
import script from "./AccidentRelative.vue?vue&type=script&lang=js&"
export * from "./AccidentRelative.vue?vue&type=script&lang=js&"
import style0 from "./AccidentRelative.vue?vue&type=style&index=0&id=52da94ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da94ed",
  null
  
)

export default component.exports